import { render, staticRenderFns } from "./bless_sort.vue?vue&type=template&id=cbba11b4&scoped=true&"
import script from "./bless_sort.vue?vue&type=script&lang=js&"
export * from "./bless_sort.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./bless_sort.vue?vue&type=style&index=0&id=cbba11b4&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../wx-ktv-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "cbba11b4",
  "53184419"
  
)

export default component.exports